<!--
 * @Author: awu
 * @Date: 2020-11-16 21:47:34
 * @LastEditors: pengyong
 * @LastEditTime: 2020-12-09 20:19:57
 * @Description: 基本资料
-->
<template>
    <div class="userInfoConfig">
        <HeadLine>{{ userInfoConfig.h1 }}</HeadLine>
        <div class="account">{{ userInfoConfig.zh }}：{{ userInfo.phone || userInfo.email || "" }}</div>
        <div class="item">
            <span class="title">{{ userInfoConfig.gj }}:</span>
            <div class="bc">
                <el-select filterable class="select" v-model="country" :placeholder="$t('register').countryPlaceholder">
                    <el-option v-for="item in countrys" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </div>
        </div>
        <div class="item">
            <span class="title">{{ userInfoConfig.name }}<span style="color:red;font-weight:900">*</span>:</span>
            <div class="bc">
                <input v-model="name" type="text" />
            </div>
        </div>
        <!-- <div class="item">
            <span class="title">{{ userInfoConfig.gs }}<span style="color:red;font-weight:900">*</span>:</span>
            <div class="bc">
                <input v-model="company" type="text" />
            </div>
        </div> -->
        <div class="item">
            <span class="title">{{ userInfoConfig.yxcp }}:</span>
            <div class="bc">
                <input v-model="purpose" type="text" />
            </div>
        </div>
        <div class="btn">
            <div class="save">
                <CommonButton fontSize="14px" :disabled="disabled" @click="handleSubmit"> {{ userInfoConfig.bc }}</CommonButton>
            </div>
            <!-- <div class="exit" @click="handleLogout">{{ $t("userCenter").exit }}</div> -->
        </div>
    </div>
</template>

<script>
import api from "@/api";
import CommonButton from "@/components/CommonButton";
import HeadLine from "./components/HeadLine";
import { mapState } from "vuex";
export default {
    components: {
        CommonButton,
        HeadLine
    },
    data() {
        return {
            countrys: [],
            country: "",
            name: "",
            company: "",
            purpose: ""
        };
    },
    computed: {
        ...mapState(["userInfo"]),
        userInfoConfig() {
            return this.$t("userInfo");
        },
        disabled() {
            return !this.country;
        }
    },
    mounted() {
        this.getCountry();
    },
    methods: {
        handleSubmit() {
            api.setUserInfo({
                real_name: this.name,
                country_code: this.country,
                company: this.company,
                purpose: this.purpose
            }).then((res) => {
                if (res.res === 1) {
                    this.$message.success(res.mes);
                    this.$store.dispatch("getUserInfo");
                }
            });
        },
        handleLogout() {
            window.logout();
        },
        getCountry() {
            api.getCountry().then((res) => {
                if (res.res === 1) {
                    const defaultLanguage = localStorage.getItem("language") || "zh";
                    this.countrys = res.country.map((item) => {
                        return {
                            value: item.code,
                            label: defaultLanguage === "zh" ? item.zh : item.en
                        };
                    });
                    console.log(this.countrys);
                }
            });
        }
    },
    watch: {
        userInfo: {
            handler(userInfo) {
                if (userInfo) {
                    this.name = userInfo.real_name;
                    this.company = userInfo.company;
                    this.country = userInfo.country_code;
                    this.purpose = userInfo.purpose;
                }
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped>
.userInfoConfig {
    padding-top: 40px;
    font-size: 14px;
    .account {
        margin: 30px 0;
        color: rgba(95, 113, 133, 1);
    }
    .item {
        width: 100%;
        height: 33px;
        display: flex;
        align-items: center;
        font-size: 14px;
        color: rgba(9, 70, 140, 1);
        margin-bottom: 20px;
        .title {
            width: 160px;
            text-align: right;
            margin-right: 13px;
            font-weight: 500;
        }
        .bc {
            height: 100%;
            width: 220px;
            background: rgba(9, 70, 140, 0.18);
            border-radius: 13px;
            color: rgba(9, 70, 140, 1);
            .select {
                height: 33px;
                border-radius: 13px;
                width: 100%;
                /deep/ .el-input {
                    font-size: 11px;
                    height: 100%;
                    // .el-input__suffix {
                    //     right: 10px;
                    //     bottom: 10px;
                    //     width: 43px;
                    //     height: 33px;
                    //     .el-input__suffix-inner {
                    //         top: -3px !important;
                    //         position: absolute;
                    //     }
                    //     input {
                    //         font-weight: 600;
                    //         color: rgba(9, 70, 140, 1);
                    //     }
                    // }
                    .el-input__inner {
                        height: 33px;
                        border: none;
                        background: transparent;
                        font-weight: 600;
                        color: rgba(9, 70, 140, 1);
                        font-size: 15px;
                    }

                    .el-select__caret {
                        font-size: 16px;
                        color: rgba(9, 70, 140, 1);
                    }
                    ::-webkit-input-placeholder {
                        color: rgba(9, 70, 140, 1);
                    }
                }
            }
            input {
                width: 100%;
                height: 100%;
                border: 0;
                background-color: transparent;
                box-sizing: border-box;
                padding: 2px 10px;
                font-size: 12px;
                font-weight: 600;
                color: rgba(9, 70, 140, 1);
                &::-webkit-input-placeholder {
                    color: rgba(9, 70, 140, 1);
                }
            }
        }
    }
    .btn {
        border-radius: 12px;
        margin-top: 60px;
        display: flex;
        align-items: center;
        .save {
            width: 97px;
            height: 39px;
            margin-left: 91px;
        }
        .exit {
            width: 97px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: #f4f4f4;
            border-radius: 12px;
            margin-left: 23px;
            color: rgba(9, 70, 140, 1);
            font-weight: 600;
            font-size: 14px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/user/userInfo.vue